export default __webpack_public_path__ + "static/simpozij-rudnik-sitarjevec-ff71611f8c23970cb156d4824d42f5a6.pdf";